import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";

export default class SettingsModuleAccountAdministration extends SettingsModule {

    constructor() {
        super({
            name                     : "Account administration",
            description              : "",
            svgIcon                  : "isvg-administration",
            typeLabel                : "Organization account",
            settingsUrl              : "settings/account-administration",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.canDisable         = false
        this.hasStatus          = false
    }

}
